import { Component, isDevMode, OnInit, HostListener } from '@angular/core';
import { AuthService } from "./services/auth/auth.service";
import { CookieService } from "ngx-cookie-service";
import { Router } from '@angular/router';
import { UsersService } from "./services/users/users.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'lpj_make_ui';

  constructor(
    private authService: AuthService,
    private cookieService: CookieService,
    private router: Router,
    private userService: UsersService
  ) {
    // Adiciona listener de clique para atualizar o token
    document.addEventListener('click', () => {
      this.authService.updateTokenOnInteraction();
    });
  }

  @HostListener('document:click')
  async onDocumentClick() {
    // Não redireciona se estiver na rota de password
    if (this.router.url.startsWith('/password/')) {
      return;
    }

    const token = localStorage.getItem('token');
    
    if (token) {
      try {
        const tokenData = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        if (tokenData.exp < currentTime) {
          localStorage.removeItem('token');
          await this.router.navigate(['/login']);
          return;
        }
        if (tokenData.exp - currentTime < 300) {
          const response: any = await this.authService.authExpired();
          if (response && response.token) {
            localStorage.setItem('token', response.token);
          } else {
            localStorage.removeItem('token');
            await this.router.navigate(['/login']);
          }
        }
      } catch (error) {
        localStorage.removeItem('token');
        await this.router.navigate(['/login']);
      }
    } else {
      await this.router.navigate(['/login']);
    }
  }

  async ngOnInit() {
    console.log(isDevMode() ? 'Development!' : 'Production!')
  }
}
